import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import stl from "@/pages/checkout/finance-checkout/FreeFinanceFormPage.module.css";
import validateStyles from "./ValidateInfoFromSema.module.css";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import useHelpers from "@hooks/useHelpers";
import useButtonLoading, { dispatchButtonLoading } from "@hooks/useButtonLoading";
import Loader from "@componentsShared/Loader/Loader";
import { useLocation } from "react-router-dom";
import useBoolean from "@hooks/useBoolean";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { Icon } from "@syarahtech/ui";
import useApi from "@hooks/useApi";
import api__getOrderDetails from "@/apis/arib/api__getOrderDetails";
import { trackEvents } from "@/common/events/events";
import useTimeout from "@hooks/useTimeout";
var ValidateInfoFromSema = function ValidateInfoFromSema() {
  var _useAribFinance, _useAribFinance$state3;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useAribFinance$state = useAribFinance().state,
    orderData = _useAribFinance$state.orderData,
    postData = _useAribFinance$state.postData,
    workInfo = _useAribFinance$state.workInfo;
  var action__updateOrderInfo = useAribFinance().actions.action__updateOrderInfo;
  var post_id = useAribFinance().queryParams.post_id;
  var _useAribFinance$remot = useAribFinance().remote_actions,
    fetch__AribSendOtop = _useAribFinance$remot.fetch__AribSendOtop,
    fetch__deleteFinanceOrder = _useAribFinance$remot.fetch__deleteFinanceOrder;
  var buttonLoading = useButtonLoading();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  var params = new URLSearchParams(location.search);
  var payment_success = params.get("payment_status");
  var paymentToast = useBoolean(false);
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _useAribFinance$state2 = (_useAribFinance = useAribFinance()) === null || _useAribFinance === void 0 ? void 0 : (_useAribFinance$state3 = _useAribFinance.state) === null || _useAribFinance$state3 === void 0 ? void 0 : _useAribFinance$state3.orderData,
    order_id = _useAribFinance$state2.order_id;
  var helper__paymentEnabled = useAribFinance().helpers.helper__paymentEnabled;
  //hide success toast after 3 seconds
  useTimeout(paymentToast.setFalse, 3000);
  var _useApi = useApi([order_id], function () {
      return api__getOrderDetails(Number(order_id));
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    apiData = _useApi2[2];
  var renderToast = function renderToast() {
    return /*#__PURE__*/React.createElement("div", {
      className: "relative mx-auto flex-1 max-w-[520px]"
    }, /*#__PURE__*/React.createElement("div", {
      className: "border border-solid border-success-90 bg-[#E6FBE7] flex rounded px-3 py-2 gap-2 w-full flex-1"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--check-circle-rounded",
      className: "text-success"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-neutral-50 text-sm font-medium"
    }, tShort("arib/payment_toast_success_message", {
      ns: "web_checkout_finance"
    }))));
  };
  useEffect(function () {
    var _apiData$data;
    if (apiData && apiData !== null && apiData !== void 0 && (_apiData$data = apiData.data) !== null && _apiData$data !== void 0 && _apiData$data.data) {
      var data = apiData.data.data;
      var g4_data = (data === null || data === void 0 ? void 0 : data.g4_data) || {};
      if (helper__paymentEnabled()) {
        var _data$g4_data, _data$g4_data2, _data$g4_data3, _data$g4_data4;
        var eventFinancePaymentPayload = {
          order_id: data.order_id || data.id,
          post_id: post_id,
          payment_type: data === null || data === void 0 ? void 0 : data.payment_type,
          payment_status: data === null || data === void 0 ? void 0 : data.payment_status,
          response_code: (data === null || data === void 0 ? void 0 : data.response_code) || null,
          response_message: (data === null || data === void 0 ? void 0 : data.response_message) || null,
          inventory_type: (data === null || data === void 0 ? void 0 : (_data$g4_data = data.g4_data) === null || _data$g4_data === void 0 ? void 0 : _data$g4_data.inventory_type) || null,
          total_amount: (data === null || data === void 0 ? void 0 : data.display_amount) || null,
          payment_option: data === null || data === void 0 ? void 0 : data.payment_option,
          post_make: data === null || data === void 0 ? void 0 : (_data$g4_data2 = data.g4_data) === null || _data$g4_data2 === void 0 ? void 0 : _data$g4_data2.post_make,
          post_model: data === null || data === void 0 ? void 0 : (_data$g4_data3 = data.g4_data) === null || _data$g4_data3 === void 0 ? void 0 : _data$g4_data3.post_model,
          post_year: data === null || data === void 0 ? void 0 : (_data$g4_data4 = data.g4_data) === null || _data$g4_data4 === void 0 ? void 0 : _data$g4_data4.post_year,
          fees: data === null || data === void 0 ? void 0 : data.amount
        };
        trackEvents("finance_payment_submit", _objectSpread({}, eventFinancePaymentPayload));
        var eventFinanceOrderPayload = _objectSpread(_objectSpread({}, g4_data), {}, {
          inventory_type_string: g4_data === null || g4_data === void 0 ? void 0 : g4_data.inventory_type_string,
          order_id: (data === null || data === void 0 ? void 0 : data.order_id) || (data === null || data === void 0 ? void 0 : data.id),
          payment_option: data === null || data === void 0 ? void 0 : data.payment_option,
          payment_status: data === null || data === void 0 ? void 0 : data.payment_status,
          response_message: (data === null || data === void 0 ? void 0 : data.response_message) || null,
          response_code: (data === null || data === void 0 ? void 0 : data.response_code) || null,
          finance_type: "paid",
          fees: data === null || data === void 0 ? void 0 : data.amount,
          post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext
        });
        trackEvents("finance_order_submit", _objectSpread({}, eventFinanceOrderPayload));
      }
    }
  }, [apiData]);
  useEffect(function () {
    if (payment_success) {
      paymentToast.setTrue();
      var url = new URL(window.location.href);
      url.searchParams["delete"]("payment_status");
      window.history.replaceState({}, "", url);
    } else {
      paymentToast.setFalse();
    }
  }, [payment_success]);
  var RequestOTPFromSema = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _postData$g4Data, _postData$g4Data2, _postData$g4Data3, _postData$g4Data4, _postData$g4Data5, _postData$g4Data6;
      var response, _response$data, _response$data2, _response$data3, _response$data4, _response$data6, _response$data7, _response$data5;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatchButtonLoading(true);
            _context.n = 1;
            return fetch__AribSendOtop();
          case 1:
            response = _context.v;
            trackEvents("arib_check", {
              post_id: post_id,
              order_id: orderData === null || orderData === void 0 ? void 0 : orderData.order_id,
              post_price: postData === null || postData === void 0 ? void 0 : (_postData$g4Data = postData.g4Data) === null || _postData$g4Data === void 0 ? void 0 : _postData$g4Data.post_price,
              inventory_type: postData === null || postData === void 0 ? void 0 : (_postData$g4Data2 = postData.g4Data) === null || _postData$g4Data2 === void 0 ? void 0 : _postData$g4Data2.inventory_type_string,
              post_make: postData === null || postData === void 0 ? void 0 : (_postData$g4Data3 = postData.g4Data) === null || _postData$g4Data3 === void 0 ? void 0 : _postData$g4Data3.post_make,
              post_model: postData === null || postData === void 0 ? void 0 : (_postData$g4Data4 = postData.g4Data) === null || _postData$g4Data4 === void 0 ? void 0 : _postData$g4Data4.post_model,
              post_year: postData === null || postData === void 0 ? void 0 : (_postData$g4Data5 = postData.g4Data) === null || _postData$g4Data5 === void 0 ? void 0 : _postData$g4Data5.post_year,
              post_condition: postData === null || postData === void 0 ? void 0 : (_postData$g4Data6 = postData.g4Data) === null || _postData$g4Data6 === void 0 ? void 0 : _postData$g4Data6.post_condition,
              user_salary: workInfo === null || workInfo === void 0 ? void 0 : workInfo.salary,
              finance_type: helper__paymentEnabled() ? "paid" : "free"
            });
            if (!response) {
              _context.n = 7;
              break;
            }
            dispatchButtonLoading(false);
            // ORDER IS IMPORTANT dont change the order of these if statements
            if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.skipToUploadPage) === true)) {
              _context.n = 2;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 5
            }));
          case 2:
            if (!(response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.backToForm)) {
              _context.n = 3;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 7
            }));
          case 3:
            if (!((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) == 120 || (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) == 500)) {
              _context.n = 4;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 9
            }));
          case 4:
            if (!((response === null || response === void 0 ? void 0 : response.code) == 230)) {
              _context.n = 5;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 13,
              errorMessage: response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.error
            }));
          case 5:
            if (!((response === null || response === void 0 ? void 0 : response.code) == 0 || (response === null || response === void 0 ? void 0 : response.status) == 429)) {
              _context.n = 6;
              break;
            }
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 13,
              error_message: t("verification_code_attempts_exceeded_try", {
                ns: "web_checkout_finance"
              }),
              error_title: t("error_failed_send_verification_code", {
                ns: "web_checkout_finance"
              })
            }));
          case 6:
            action__updateOrderInfo({
              "transaction_id": response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.transactionID
            });
            action__updateOrderInfo({
              "skipToUploadPage": response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.skipToUploadPage
            });
            return _context.a(2, navigateTo("/finance-apply-arib", {
              post_id: post_id,
              financestep: 4
            }));
          case 7:
            dispatchButtonLoading(false);
          case 8:
            return _context.a(2, null);
        }
      }, _callee);
    }));
    return function RequestOTPFromSema() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex mx-auto lg:max-w-[909px] lg:mt-8 items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[76px]"
  }), paymentToast.value ? /*#__PURE__*/React.createElement(React.Fragment, null, renderToast()) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative mx-auto flex-1 max-w-[520px] h-[38px]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-[76px]"
  })), paymentToast.value ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center max-w-[520px] mx-auto px-4 mb-10 md:hidden mt-4"
  }, renderToast())) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center max-w-[520px] mx-auto px-4 mb-10 md:hidden mt-4 h-[38px]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center max-w-[520px] md:p-10 flex-col items-start  mx-auto mt-[100px] md:mt-[72px] !w-[80%] max-w-[1152px] max-lg:!w-[90%] md:after:content-[''] md:after:bg-[#fafcff] md:after:fixed md:after:bottom-0 md:after:left-0 md:after:w-full md:after:h-full md:after:z-[-1] md:rounded-[16px] md:border md:border-[#EBF0F7] md:bg-white md:border-solid"
  }, /*#__PURE__*/React.createElement("i", {
    className: validateStyles.otpIcon
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-2xl font-bold leading-8 max-w-[313px]"
  }, t("check_credit_information", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8 mt-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-center text-base font-medium leading-6"
  }, t("code_used_securely_verify_financial", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#6C7A8D] text-center text-base font-medium leading-6"
  }, t("make_sure_receive_messages_number", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: RequestOTPFromSema,
    className: ["relative rounded border-none  text-white text-base font-bold leading-6 w-full h-12 mt-12 flex items-center justify-center",
    // !approvedByUser||buttonLoading ? "pointer-events-none bg-[#EBF0F7]" : "blueBtn bg-[#3C56D4]"
    buttonLoading ? "pointer-events-none bg-[#EBF0F7]" : "blueBtn bg-[#3C56D4]"].join(" ")
  }, t("send_otp", {
    ns: "web_checkout_finance"
  }), buttonLoading && /*#__PURE__*/React.createElement(Loader, {
    className: "!bg-transparent !absolute w-full h-full m-0 [zoom:0.6] [backdrop-filter:blur(1px)]"
  }))), ShowPopUp && /*#__PURE__*/React.createElement(BottomSheetPopup, {
    noPadding: true,
    className: stl.BottomSheetPopup,
    show: ShowPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.freeFinanceCancelOreder
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.freeFinanceCancelIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("sure_cancel_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", null, t("information_saved_need_refill_data", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "blueBtn",
    onClick: function onClick() {
      setShowPopUp(false);
    }
  }, t("continue_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "whtBtn",
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!(orderData !== null && orderData !== void 0 && orderData.order_uuid)) {
              _context2.n = 1;
              break;
            }
            setShowPopUp(false);
            // setLoader(true);
            _context2.n = 1;
            return fetch__deleteFinanceOrder(orderData === null || orderData === void 0 ? void 0 : orderData.order_uuid);
          case 1:
            navigateTo("/cardetail/".concat(post_id));
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }))
  }, t("cancel_submitting_application", {
    ns: "web_tracking"
  })))));
};
export default ValidateInfoFromSema;